'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/camelize.js
// module id = 163
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460